import { css } from "@emotion/react";

import { DesignToken } from "@livechat/design-system-react-components";

import { withVar } from "themes/helpers";

export const wrapperStyles = css`
  margin: 0 auto 20px;

  .highcharts-background {
    fill: var(${DesignToken.SurfacePrimaryDefault});
  }

  .highcharts-legend-title text {
    fill: ${withVar(DesignToken.ContentBasicPrimary)};
    font-size: 13px;
    font-weight: normal !important;
    transform: translate(0px, -10px);
  }

  .highcharts-title + .highcharts-legend {
    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
      display: none;
    }
  }

  .highcharts-crosshair {
    display: none;
  }

  .highcharts-yaxis-labels text {
    display: none !important;
  }

  .highcharts-yaxis-labels text:nth-child(3n) {
    display: block !important;
  }
`;
